import { AddCustomerOwnerCommand } from "@/models/club";
import customerService from "@/services/customer";
import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

type Props = {
  doNavigate?: boolean;
  close?: (customerId: number) => void;
};

function useAssignCustomer({ doNavigate = true, close }: Props) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (command: AddCustomerOwnerCommand) => {
      if (!command.customerId) throw new Error("مشتری انتخاب نشده است");
      return customerService.assignCustomer(command);
    },
    onSuccess: async (_, command) => {
      queryClient.setQueriesData({ queryKey: ["customer-membership", command.customerId] }, true);
      await Promise.all([
        "customers", "customersPagination", "customer-membership", "customers-owner-selection",
        "getCustomerCount", "getCustomerCountChart", "merchant-dashboard-overview", "barber-dashboard",
        "getCustomerByPhoneNumber", "getCustomerInMerchantByPhoneNumber",
      ].map(key => queryClient.invalidateQueries({ queryKey: [key] })));
      notifications.show({ title: "عملیات موفق", message: "مشتری به فهرست مشتریان شما اضافه شد", color: "green" });
      if (close) close(command.customerId!);
      else if (doNavigate) navigate("/dashboard/customers");
    },
  });
}

export default useAssignCustomer;
